import React from "react";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

// Paginador reutilizable para listados paginados del lado del cliente.
// Autor: IA (Claude) — 2026-09-15
export const OPCIONES_POR_PAGINA = [25, 50, 100];

const PaginadorListado = ({ pagina, totalRegistros, porPagina, onCambiarPagina, onCambiarPorPagina }) => {
    const totalPaginas = Math.max(1, Math.ceil(totalRegistros / porPagina));
    const desde = totalRegistros === 0 ? 0 : (pagina - 1) * porPagina + 1;
    const hasta = Math.min(pagina * porPagina, totalRegistros);

    return (
        <div className="paginador-listado">
            <div className="paginador-listado-info">
                {desde.toLocaleString("es-MX")}–{hasta.toLocaleString("es-MX")} de {totalRegistros.toLocaleString("es-MX")}
            </div>
            <div className="paginador-listado-controles">
                {onCambiarPorPagina && (
                    <select
                        aria-label="Registros por página"
                        value={porPagina}
                        onChange={(e) => onCambiarPorPagina(Number(e.target.value))}
                    >
                        {OPCIONES_POR_PAGINA.map((op) => (
                            <option key={op} value={op}>{op} por página</option>
                        ))}
                    </select>
                )}
                <button type="button" aria-label="Página anterior" disabled={pagina <= 1} onClick={() => onCambiarPagina(pagina - 1)}>
                    <ChevronLeftIcon />
                </button>
                <span className="paginador-listado-pagina">{pagina} / {totalPaginas}</span>
                <button type="button" aria-label="Página siguiente" disabled={pagina >= totalPaginas} onClick={() => onCambiarPagina(pagina + 1)}>
                    <ChevronRightIcon />
                </button>
            </div>
        </div>
    );
};

export default PaginadorListado;
